var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Menue"},[_c('CellGroup',{on:{"on-click":_vm.HandleClick}},[_c('Cell',{staticClass:"item-hover",attrs:{"title":"退出登录","name":"Logout"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }